import Unavailable from "@/components/Unavailable";

export default function Checkout() {
  return (
    <div className="max-w-3xl mx-auto py-10">
      <div className="eyebrow">RÉSERVATION</div>
      <h1 data-testid="checkout-title" className="font-display text-3xl mb-5">Paiement.</h1>
      <Unavailable
        testid="checkout-unavailable"
        title="Les paiements ne sont pas encore activés."
        text="Nous ne collectons aucune coordonnée bancaire et aucune transaction n'est possible aujourd'hui. Le modèle tarifaire est publié à l'avance pour que vous sachiez à quoi vous attendre."
        to="/tarifs"
        linkLabel="Voir les tarifs"
      />
    </div>
  );
}
